import styled from "styled-components";

export const PageRoot = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: hsl(${({ theme }) => theme.colors.background});
`;
